import {
  GET_REGION_PENDING,
  GET_REGION_SUCCESS,
  GET_REGION_ERROR,
  POST_REGION_PENDING,
  POST_REGION_SUCCESS,
  POST_REGION_ERROR,
  PUT_REGION_PENDING,
  PUT_REGION_SUCCESS,
  PUT_REGION_ERROR,
  DELETE_REGION_PENDING,
  DELETE_REGION_SUCCESS,
  DELETE_REGION_ERROR,
  REGION_DATA,
  SET_REGION_MODAL,
} from "../../../actions/master-data/region";

const initialState = {
  pending: false,
  error: null,
  data: null,
  detailData: null,
  isOpenModal: false,
  modalType: "",
};

const region = (state = initialState, action) => {
  switch (action.type) {
    case GET_REGION_PENDING:
      return {
        ...state,
        pending: true,
      };
    case GET_REGION_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data,
      };
    case GET_REGION_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case POST_REGION_PENDING:
      return {
        ...state,
        pending: true,
      };
    case POST_REGION_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data,
      };
    case POST_REGION_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case PUT_REGION_PENDING:
      return {
        ...state,
        pending: true,
      };
    case PUT_REGION_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data,
      };
    case PUT_REGION_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case DELETE_REGION_PENDING:
      return {
        ...state,
        pending: true,
      };
    case DELETE_REGION_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data,
      };
    case DELETE_REGION_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case REGION_DATA:
      return {
        ...state,
        detailData: action.data,
      };
    case SET_REGION_MODAL:
      return {
        ...state,
        isOpenModal: action.data.isOpen,
        modalType: action.data.modalType,
      };
    default:
      return state;
  }
};

export default region;
